import { AbstractIntProperty } from './AbstractIntProperty'

export class UserId extends AbstractIntProperty {
  KEY: string = 'userId'
}
